import dragVerify from "./index.vue";

dragVerify.install = function(Vue) {
  Vue.component(dragVerify.name, dragVerify);
};

export default dragVerify;
